import { forwardRef } from 'react';
import './styles.scss';
import { useTranslation } from 'react-i18next';

import { EditStepBtn } from '@pages/checkout/components';
import { ReactComponent as LockIcon } from '@assets/images/lock_keyhole.svg';

interface TitleProps {
  current: number;
  active: number;
  title: string;
  onClick?: () => void;
  children?: React.ReactNode;
  numberText: string;
  isEditHidden?: boolean;
}

export const Title = forwardRef<HTMLElement, TitleProps>(function Title(
  { title, current, numberText, active, onClick, children, isEditHidden },
  ref
) {
  const { t } = useTranslation();
  const isInactive = current === active;

  return (
    <span
      ref={ref}
      className={
        isInactive
          ? 'checkout__title'
          : 'checkout__title checkout__title--inactive'
      }
    >
      <span className="checkout__title-header">
        <span className="checkout__title-num">{numberText}</span>
        <span>{title}</span>

        {current >= active
          ? null
          : !isEditHidden && (
              <EditStepBtn title={t('checkout.editBtn')} onClick={onClick} />
            )}

        {current > active ? (
          <LockIcon
            className={
              !isInactive
                ? 'checkout__lock-icon'
                : 'checkout__lock-icon--inactive'
            }
          />
        ) : null}
      </span>
      {!isInactive && current < active ? (
        <span className="checkout__children">{children}</span>
      ) : null}
    </span>
  );
});
